<template>
    <div>
        <div v-for="option, idx in field.options" :key="idx">
            <input type="radio" :value="option" :checked="value===option" @change="update($event)">
            <label>{{option}}</label>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'v-radio-field',
        props:['value', 'field'],
        methods:{
            update(ev){
                this.$emit('input', ev.target.value)
            }
        }
    }
</script>

<style scoped lang="scss">
</style>
